<template>

   <input-child
      v-bind="getInputProps({})"
   >
      <template #inputGroup="{  }">
         <div class="input-mce" :class="inputClass" ref="editor">
            <slot></slot>
         </div>
      </template>
      <template #hidden="{}">
         <template v-if="name">
            <input type="hidden" :name="name" :value="inputValue">
         </template>
      </template>
   </input-child>

</template>

<script>
    import Quill from 'quill';

    import mixinCommon from './mixinCommon';
    import mixinInput from './mixinInput';

    import Input from './Input';

    export default {
        mixins: [ mixinCommon, mixinInput ],
        components: {
            'input-child': Input
        },
        props: {
            ...Input.props
        },
        data() {
            return {
                quill: null,
                delta: null
            };
        },
        mounted() {
            this.quill = new Quill(
                this.$refs.editor,
                {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ 'align': [] }],
                            ['blockquote'],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        ]
                    },
                    placeholder: this.placeholder,
                    theme: 'snow'
                }
            );
            this.quill.on('text-change', ( delta, oldDelta, source ) => {
                this.delta = delta;
                this.inputValue = this.getContent();
            });

            if( !this.inputValue ) {
                this.inputValue = this.getContent();
            }
            else {
                this.setContent( this.inputValue );
            }

            this.$watch('value', ( value ) => {
                this.setContent( value );
            });
        },
        methods: {
            getContent() {
               return this.quill.root.innerHTML.replace("<p><br></p>", "");
            },
            setContent( textOrHtml ) {
               this.quill.root.innerHTML = textOrHtml;
            },
            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( Input, overrideProps );
            }
        }
    }
</script>
